import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { storableError } from '../../util/errors';
import { disconnectGoogleCalendar } from '../../util/api';
import { fetchCurrentUser } from '../../ducks/user.duck';

export const disconnectGoogleCalendarThunk = createAsyncThunk(
  'GoogleCalendarSettingsPage/disconnectGoogleCalendar',
  (_, { dispatch, rejectWithValue }) => {
    return disconnectGoogleCalendar()
      .then(() => dispatch(fetchCurrentUser()))
      .catch(e => rejectWithValue(storableError(e)));
  }
);

export const disconnectGoogleCalendarAccount = () => dispatch => {
  return dispatch(disconnectGoogleCalendarThunk()).unwrap();
};

const googleCalendarSettingsPageSlice = createSlice({
  name: 'GoogleCalendarSettingsPage',
  initialState: {
    disconnectGoogleCalendarInProgress: false,
    disconnectGoogleCalendarError: null,
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(disconnectGoogleCalendarThunk.pending, state => {
        state.disconnectGoogleCalendarInProgress = true;
        state.disconnectGoogleCalendarError = null;
      })
      .addCase(disconnectGoogleCalendarThunk.fulfilled, state => {
        state.disconnectGoogleCalendarInProgress = false;
      })
      .addCase(disconnectGoogleCalendarThunk.rejected, (state, action) => {
        state.disconnectGoogleCalendarInProgress = false;
        state.disconnectGoogleCalendarError = action.payload;
      });
  },
});

export default googleCalendarSettingsPageSlice.reducer;

export const loadData = () => {
  return fetchCurrentUser();
};
